<div [hidden]="!loading">
  <div class="loading-spinner">
  	<div class="loader"></div>
  </div>
</div>
